'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userType = require('utilities/user-type');

var _userType2 = _interopRequireDefault(_userType);

var _userAddForm = require('./user-add-form.html');

var _userAddForm2 = _interopRequireDefault(_userAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _userAddForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    accessLevels: '<',
    onUserChanged: '&',
    requireUserTypeSelection: '<'
  },
  controller: function () {
    function UserAddFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, UserAddFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(UserAddFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.user = this.user || {};
        this.userTypes = _userType2.default;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onUserChanged(this.EventEmitter({
          user: this.user
        }));
      }
    }, {
      key: 'setSelectedCompany',
      value: function setSelectedCompany(_ref) {
        var company = _ref.company;

        this.user.TypeReferenceId = company && company.MemberId || null;
      }
    }, {
      key: 'setSelectedRegulator',
      value: function setSelectedRegulator(_ref2) {
        var regulator = _ref2.regulator;

        this.user.TypeReferenceId = regulator && regulator.RegulatorId || null;
      }
    }]);

    return UserAddFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/user-add-form/user-add-form.component.js